var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-menu-main",style:({
    width: (_vm.widthSize + "px"),
    minWidth: !_vm.showMe ? '0' : (_vm.widthSize + "px"),
    maxWidth: !_vm.showMe ? '0' : (_vm.widthSize + "px"),
    position: _vm.overlay ? 'absolute' : 'relative',
    padding: !_vm.showMe ? '0' : '5px',
    paddingLeft: !_vm.showMe ? '0' : '10px',
    transition: _vm.isTransition ? '0.3s' : '0s',
  })},[_c('div',{staticClass:"slider",on:{"mousedown":_vm.sliderMouseDown}}),_c('div',{staticClass:"slider-bar"}),(_vm.showCloseButton)?_c('img',{staticClass:"close-button",staticStyle:{"width":"23px","height":"23px","background-color":"white","border-radius":"50%","cursor":"pointer","margin":"3px"},attrs:{"src":"https://dsmlib.logistics.systems/Icons/Cancel.png","alt":""},on:{"click":_vm.closeClicked}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }